var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"responsive-container-px pa-0",attrs:{"fluid":""}},[_c('loading',{attrs:{"loading-key":_vm.loadingKey}}),_c('manage-users')],1)}
var staticRenderFns = []

export { render, staticRenderFns }